'use client'

import type { ReactElement } from 'react'
import { isLinkButton, type LinkProps } from './Link.types'
import { LinkButton } from './_components/LinkButton.client'
import { LinkText } from './_components/LinkText.client'

export type {
  LinkButtonProps,
  LinkProps,
  LinkTint,
  TextLinkProps,
  TextLinkUnderlined,
} from './Link.types'

export function Link(props: LinkProps): ReactElement {
  return isLinkButton(props) ? <LinkButton {...props} /> : <LinkText {...props} />
}
